export const LOGIN_MANAGEMENT = "[MANAGEMENT] LOGIN_MANAGEMENT";
export const LOGOUT_MANAGEMENT = "[MANAGEMENT] LOGOUT MANAGEMENT";
export const CLEAN_MANAGEMENT_STATE = "[MANAGEMENT] CLEAN_MANAGEMENT_STATE";
export const REMOVE_FLAG_TEMPORALY_PASSWORD =
  "[MANAGEMENT] REMOVE_FLAG_TEMPORALY_PASSWORD";
